import { useContext, createContext } from "react";

export const TaskShareContext = createContext(null);

export function useTaskShareContext() {
  return useContext(TaskShareContext);
}
